export const ADD_ADDRESS_INFORMATION_STARTED =
  'ADD_ADDRESS_INFORMATION_STARTED';
export const ADD_ADDRESS_INFORMATION_SUCCESS =
  'ADD_ADDRESS_INFORMATION_SUCCESS';
export const ADD_ADDRESS_INFORMATION_ENDED = 'ADD_ADDRESS_INFORMATION_ENDED';
export const ADD_ADDRESS_INFORMATION_ERROR = 'ADD_ADDRESS_INFORMATION_ERROR';
